// extracted by mini-css-extract-plugin
export default {"OurSchool":"OurSchool_OurSchool__9ZTil"};